import React from "react";
import { InteractiveProductZone } from "./InteractiveProductZone.jsx";
import { InteractiveProductsSettingsProvider } from "../context/interactive-product-context.jsx";
import { createPortal } from "react-dom";
import { ProductLightboxProvider } from "../product-lightbox/product-lightbox-context.js";
import { useAllProducts } from "../product-lightbox/use-all-products.js";
import { FollowProductsContextProvider } from "../context/follow-products-context.jsx";
import { AlertProvider } from "../context/alert-context.jsx";
import { isOverLazyLoadedIndex, useLazyLoading } from "../../product-lazy-loading/lazy-loading-hooks";
import { useContainersFromProductsByPages } from "../../containers/query-interactive-container.js";
import { ShowAllZonesProvider } from "../../show-all-zones/show-all-zones.jsx";

export const InteractiveProducts = ({ data }) => {
	const { productsByPages, enableLazyLoading, ...dataRest } = data;

	const { containers } = useContainersFromProductsByPages(productsByPages);

	const allProducts = useAllProducts(productsByPages);

	const { loadUpToIndex } = useLazyLoading({ enableLazyLoading, containers });

	return (
		<InteractiveProductsSettingsProvider value={dataRest}>
			<FollowProductsContextProvider allProducts={allProducts}>
				<ShowAllZonesProvider>
					<AlertProvider>
						<ProductLightboxProvider allProducts={allProducts}>
							{Object.entries(productsByPages).flatMap(
								([pageIndex, products]) => {

									const pageIndexParsed = parseInt(pageIndex);

									if (isNaN(pageIndexParsed)) {
										console.error(
											`[INTERACTIVE PRODUCTS] Page index \`${pageIndex}\` on productsByPages obj is not a number.`
										);
										return null;
									}

									const containerElement = containers[pageIndexParsed];

									if (
										isOverLazyLoadedIndex({
											currentIndex: pageIndexParsed,
											loadUpToIndex,
										})
									) {
										return null;
									}

									// fallback, nerenderování, pokud není container -> Vypisování erroru, pokud není definován kontejner pro danou stránku
									// je řešený v useContainersFromProductsByPages
									if (!containerElement) {
										return null;
									}

									return products.map((product) => {
										return createPortal(
											<InteractiveProductZone
												key={product.uid}
												product={product}
											/>,
											containerElement
										);
									});
								}
							)}
						</ProductLightboxProvider>
					</AlertProvider>
				</ShowAllZonesProvider>
			</FollowProductsContextProvider>
		</InteractiveProductsSettingsProvider>
	);
};
